import * as types from 'store/actions/types';

export const initialState = {
	MAIN_WEB: {
		error: false,
		loading: true,
		data: []
	},
	VOD_WEB: {
		error: false,
		loading: true,
		data: []
	},
	SERIES_WEB: {
		error: false,
		loading: true,
		data: []
	},
	KIDS_WEB: {
		error: false,
		loading: true,
		data: []
	},
	START_WEB: {
		error: false,
		loading: true,
		data: []
	},
	sectionsName: ''
};

export default function (state = initialState, action = {}) {
	const { groupLabel, payload, type } = action;

	switch (type) {
		case types.SECTION_GROUPS_LOADING:
			return initialState;

		case types.SECTION_GROUPS_SUCCESS:
			return {
				...state,
				sectionsName: groupLabel,
				[groupLabel]: {
					error: false,
					loading: true,
					data: [...state[groupLabel].data, payload]
				}
			};

		case types.SECTION_GROUPS_ERROR:
			return {
				...state,
				[groupLabel]: {
					error: true,
					loading: false,
					data: [...state[groupLabel].data]
				}
			};

		case types.SECTION_GROUPS_LOADING_FINISH:
			return {
				...state,
				[groupLabel]: {
					error: false,
					loading: false,
					data: [...state[groupLabel].data]
				}
			};

		// Clear data
		case types.SECTION_GROUPS_CLEAR:
			return initialState;

		default:
			return state;
	}
}
